export default "__VITE_ASSET__98dd492c__"